import { Router } from '@angular/router';

import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VoucherGuard {
  constructor(public router: Router) {}

  /**
   * Guards the Voucher Redemption page url access based on the Feature flag configured in environment
   * @returns boolean value based on Feature flag.
   */
  canActivate(): boolean {
    const showVoucher = environment.beyond.featureFlags.showVoucher;
    if (showVoucher) {
      return true;
    }
    this.router.navigate(['/pagenotfound']);
    return false;
  }
}
